import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import ModalConID from "../ModalConID";
import { useInsertConText } from "../../Context/InsertContext";
import ModalUser from "../SetCommander/ModalUser";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import {
  FetchAxiosFile,
  FetchAxiosPost,
  FetchAxiosPut,
} from "../../../api/axios";
import ModalAssignUser from "../SetCommander/ModalAssignUser";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import LoadingPerson from "../../TESTPage/LoadingPerson";

const API_URL = process.env.REACT_APP_API_CORS;
function EditAssign(props) {
  const { onButtonClick, id, assignID } = props;
  const { insert, setInsert } = useInsertConText();
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [userAssignName, setUserAssignName] = useState(null);
  const [userAssignID, setUserAssignID] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [position_Name, setPosition_Name] = useState(null);
  const [position_ID, setPosition_ID] = useState(null);
  const [userAssignData, setUserAssignData] = useState(null);
  const [userAssignDataOrg, setUserAssignDataOrg] = useState(null);
  const [assignOrgId, setAssignOrgId] = useState(null);
  const [assignId, setAssignId] = useState(null);
  const [assignUserId, setAssignUserId] = useState(null);
  const [assignOrgName, setAssignOrgName] = useState(null);
  const [fileUp, setFileUp] = useState(null);
  const [masterdata, setMasterdata] = useState([]);
  const [userEditData, setUserEditData] = useState([]);
  const [editIDData, setEditIDData] = useState(null);
  const [editIDUser, setEditIDUser] = useState(null);
  const [editIDPosition, setEditIDPosition] = useState(null);
  const [editNamePosition, setEditNamePosition] = useState(null);
  const [assignFile, setAssignFile] = useState(null);
  const [assignUserID, setAssignUserID] = useState(null);
  const [editStartDate, setEditStartDate] = useState(null);
  const [editEndDate, setEditEndDate] = useState(null);
  const [editStatus, setEditStatus] = useState(null);
  const [editID, setEditID] = useState(null);
  const [EditFile, setEditFile] = useState(null);
  const [positionCheck, setPositionCheck] = useState(0);
  const [positionID1Check, setPositionID1Check] = useState(0);
  const [positionID2Check, setPositionID2Check] = useState(0);
  const [positionID3Check, setPositionID3Check] = useState(0);
  const [positionID4Check, setPositionID4Check] = useState(0);
  const [positionID5Check, setPositionID5Check] = useState(0);
  const [positionID6Check, setPositionID6Check] = useState(0);
  const [positionID7Check, setPositionID7Check] = useState(0);

  const [confirmModal, setconfirmModal] = useState(false);

  const token = GetCookieToken("userToken");

  const positionURL = `/api/users/position/${id}`;

  // ─── fetch functions ────────────────────────────────────────────────────────

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMasterdata(response.data.result);
    } catch (error) {
      console.error("fetchMasterData Error:", error);
    }
  };

  const fetchData = async () => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[id][0]": id,
    });
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    try {
      const response = await axios.get(url, config);
      const result = response.data.result;
      setUserEditData(result);
      setEditIDUser(result?.map(i => i.user_id));
      setEditIDPosition(result?.map(i => i.position_id));
      setEditNamePosition(result?.map(i => i.position_name));
      setAssignUserID(result?.map(i => i.assigned_by_user_id));
      setEditStartDate(result?.map(i => i.date_start));
      setEditEndDate(result?.map(i => i.date_end));
      setEditIDData(result?.map(i => i.org_id));
      setEditStatus(result?.map(i => i.status));
      setEditFile(result?.map(i => i.assign_doc?.split("public/")[1]));
      setEditID(result?.map(i => i.assign_org_id));
    } catch (error) {
      console.error("fetchData Error:", error);
    }
  };

  const fetchUserData = async (id) => {
    if (id === null) return;
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setUserAssignData(response.data.result);
    } catch (error) {
      console.error("fetchUserData Error:", error);
    }
  };

  const fetchOrgIdData = async (assign_id, id) => {
    const url = `${API_URL}/api/users/position/datatable`;
    const filterUserId = id !== null ? id : assignID;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[id][0]": assign_id,
      "filter[user_id][0]": filterUserId,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setUserAssignDataOrg(response.data.result);
    } catch (error) {
      console.error("fetchOrgIdData Error:", error);
    }
  };

  const fetchDataUser = async (id, setValue) => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setValue(() => response.data.result?.map(i => i.user_name));
    } catch (error) {
      console.error("fetchDataUser Error:", error);
    }
  };

  const fetchDataAssignUser = async (id, setValue) => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setValue(() => response.data.result?.map(i => i.user_name));
    } catch (error) {
      console.error("fetchDataAssignUser Error:", error);
    }
  };

  // ─── toggle handlers ─────────────────────────────────────────────────────────

  const toggleRightCanvasT = async () => {
    setLoading(true);
    // reset state
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);

    setOpen(prev => !prev);

    await Promise.all([fetchMasterData(), fetchData()]);

    setLoading(false);
  };

  const toggleRightCanvasF = async () => {
    setLoading(true);
    await onButtonClick();
    setOpen(prev => !prev);
    setLoading(false);
  };

  const toggleRightCanvasFS = async () => {
    setLoading(true);
    await handleClearFile();
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setUserAssignDataOrg(null);
    setUserAssignData(null);
    setAssignId(null);
    setLoading(false);
    setOpen(prev => !prev);
  };

  // ─── submit ──────────────────────────────────────────────────────────────────

  const data = {
    position_id: position_ID,
    position_name: position_Name,
    user_id: userID !== null ? userID : `${editIDUser}`,
    is_default: 0,
    date_start: startDate ? startDate : `${editStartDate}`,
    date_end: endDate ? endDate : `${editEndDate}`,
    org_id: assignOrgId !== null ? assignOrgId : `${editIDData}`,
    status: status !== null ? status : `${editStatus}`,
    assigned_by_user_id:
      assignUserId !== null ? assignUserId : `${assignUserID}`,
    assign: 1,
    assign_org_id: assignId,
  };

  const handleSubmit = async () => {
    setLoading(true);
    await FetchAxiosPut(positionURL, data, token);
    if (fileUp !== null) {
      const url_file = `/api/users/position/file/${id}`;
      await FetchAxiosFile(url_file, token, fileUp);
    }
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setUserAssignDataOrg(null);
    setUserAssignData(null);
    setAssignId(null);
    await toggleRightCanvasF();
    setLoading(false);
  };

  // ─── useEffects ──────────────────────────────────────────────────────────────

  useEffect(() => {
    if (insert.task === "user_ผู้บังคับบัญชา") {
      setUserID(insert.insert_id);
      setUserName(insert.insert_name);
    }
    if (insert.task === "Assign_ผู้บังคับบัญชา") {
      setUserAssignName(insert.insert_name);
      setUserAssignID(insert.insert_id);
    }
  }, [insert]);

  useEffect(() => {
    if (userAssignID !== null) {
      setLoading(true);
      setUserAssignDataOrg(null);
      fetchUserData(userAssignID).finally(() => setLoading(false));
    }
  }, [userAssignID]);

  useEffect(() => {
    if (assignId !== null) {
      setLoading(true);
      fetchOrgIdData(assignId, userAssignID).finally(() => setLoading(false));
    }
  }, [assignId]);

  useEffect(() => {
    if (editIDUser !== null) {
      fetchDataUser(editIDUser, setUserName);
    }
  }, [editIDUser]);

  useEffect(() => {
    if (assignUserID !== null) {
      setLoading(true);
      Promise.all([
        fetchDataAssignUser(assignUserID, setUserAssignName),
        fetchUserData(assignUserID),
      ]).finally(() => setLoading(false));
    }
  }, [assignUserID]);

  useEffect(() => {
    if (editID !== null) {
      setLoading(true);
      fetchOrgIdData(editID.toString(), assignUserID).finally(() =>
        setLoading(false)
      );
    }
  }, [editID]);

  useEffect(() => {
    if (userAssignDataOrg !== null) {
      const EditPositonCheck = userAssignDataOrg?.map(
        userOrgData => userOrgData.position_id
      );
      if (`${EditPositonCheck}` === "1") {
        setPositionCheck(1);
        setPositionID1Check(2); setPositionID2Check(3); setPositionID3Check(4);
        setPositionID4Check(5); setPositionID5Check(6); setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "2") {
        setPositionCheck(2);
        setPositionID1Check(1); setPositionID2Check(3); setPositionID3Check(4);
        setPositionID4Check(5); setPositionID5Check(6); setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "3") {
        setPositionCheck(3);
        setPositionID1Check(2); setPositionID2Check(1); setPositionID3Check(4);
        setPositionID4Check(5); setPositionID5Check(6); setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "4") {
        setPositionCheck(4);
        setPositionID1Check(2); setPositionID2Check(3); setPositionID3Check(1);
        setPositionID4Check(5); setPositionID5Check(6); setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "5") {
        setPositionCheck(5);
        setPositionID1Check(2); setPositionID2Check(3); setPositionID3Check(4);
        setPositionID4Check(1); setPositionID5Check(6); setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "6") {
        setPositionCheck(6);
        setPositionID1Check(2); setPositionID2Check(3); setPositionID3Check(4);
        setPositionID4Check(5); setPositionID5Check(1); setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "7") {
        setPositionCheck(7);
        setPositionID1Check(2); setPositionID2Check(3); setPositionID3Check(4);
        setPositionID4Check(5); setPositionID5Check(6); setPositionID6Check(1);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "8") {
        setPositionCheck(8);
        setPositionID1Check(2); setPositionID2Check(3); setPositionID3Check(4);
        setPositionID4Check(5); setPositionID5Check(6); setPositionID6Check(7);
        setPositionID7Check(1);
      }
    }
  }, [userAssignDataOrg]);

  useEffect(() => {
    if (userAssignData !== null) {
      const configPoID = userAssignDataOrg?.map(assign => assign.position_id);
      const foundData = masterdata?.users_position?.find(
        i => i?.users_position_id === parseInt(configPoID)
      );
      setPosition_ID(foundData?.users_position_id);
      setPosition_Name(foundData?.users_position_name);
    }
  }, [userAssignDataOrg]);

  // ─── file handlers ───────────────────────────────────────────────────────────

  const handleButtonFileClick = () => {
    document.getElementById("file-input")?.click();
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) setFileUp(file);
  };

  const handleClearFile = () => {
    const fileInput = document.getElementById("file-input");
    if (fileInput) fileInput.value = null;
    setFileUp(null);
  };

  // ─── render ──────────────────────────────────────────────────────────────────

  return (
    <Fragment>
      <ConfirmModal
        modal={confirmModal}
        modalSize="md"
        modalHeaderContent="คุณต้องการที่จะแก้ไข ใช่หรือไม่?"
        onClickConfirmBtn={() => {
          handleSubmit();
          setconfirmModal(false);
        }}
        onClickCancelBtn={() => setconfirmModal(false)}
      />
      <Button className="mt-1 me-2" onClick={toggleRightCanvasT} color="warning">
        <i className="fa-solid fa-pen-to-square"></i>
      </Button>
      <Offcanvas
        style={{ border: "none" }}
        autoFocus
        direction="end"
        isOpen={open}
        toggle={toggleRightCanvasFS}
        fade
        className="fade custom-w-50"
      >
        <OffcanvasHeader style={{ background: "#2a3042", color: "white" }}>
          <i className="fa-solid fa-plus"></i>{" "}
          รายละเอียดกำหนดการปฏิบัติราชการแทน
          <div className="position-absolute top-0 end-0">
            <i
              className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4"
              style={{ cursor: "pointer" }}
              onClick={toggleRightCanvasFS}
            ></i>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {loading ? (
            <LoadingPerson />
          ) : (
            <Form
              onSubmit={e => {
                setconfirmModal(true);
                e.preventDefault();
              }}
            >
              <Row>
                <Col lg={12}>
                  <FormGroup>
                    <Label>ผู้รับมอบอำนาจ</Label>
                    <InputGroup>
                      <Input
                        readOnly
                        defaultValue={userName}
                        name="user_name"
                        placeholder=""
                        type="text"
                      />
                      <ModalUser task="user_ผู้บังคับบัญชา" />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col lg={12}>
                  <FormGroup>
                    <Label>ผู้มอบอำนาจ</Label>
                    <InputGroup>
                      <Input
                        readOnly
                        defaultValue={userAssignName}
                        name="user_name"
                        placeholder=""
                        type="text"
                        invalid={!userAssignName}
                      />
                      <ModalAssignUser task="Assign_ผู้บังคับบัญชา" />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>

              {userAssignData !== null ? (
                <Fragment>
                  <Row>
                    <Col lg={12}>
                      <FormGroup>
                        <Label>สำนัก/กอง/กลุ่ม ที่ได้รับการดูแล</Label>
                        {userAssignData?.map((assignData, index) => {
                          if (assignData.assign === 0) {
                            return assignId !== null ? (
                              <InputGroup className="my-2" key={index}>
                                <InputGroupText>
                                  <Input
                                    addon
                                    type="radio"
                                    name="other_assign"
                                    onChange={e => {
                                      setAssignId(e.target.checked ? assignData.id : null);
                                      setAssignUserId(e.target.checked ? assignData.user_id : null);
                                      setAssignOrgId(e.target.checked ? assignData.org_id : null);
                                      setAssignOrgName(e.target.checked ? assignData.org_name : null);
                                    }}
                                  />
                                </InputGroupText>
                                <Input
                                  readOnly
                                  defaultValue={assignData.org_name}
                                  style={{ cursor: "pointer", transition: "background-color 0.3s" }}
                                />
                              </InputGroup>
                            ) : editID !== null ? (
                              <InputGroup className="my-2" key={index}>
                                <InputGroupText>
                                  <Input
                                    addon
                                    type="radio"
                                    defaultChecked={editID.toString() === assignData.id}
                                    name="other_assign"
                                    onChange={e => {
                                      setAssignId(e.target.checked ? assignData.id : null);
                                      setAssignUserId(e.target.checked ? assignData.user_id : null);
                                      setAssignOrgId(e.target.checked ? assignData.org_id : null);
                                      setAssignOrgName(e.target.checked ? assignData.org_name : null);
                                    }}
                                  />
                                </InputGroupText>
                                <Input
                                  readOnly
                                  defaultValue={assignData.org_name}
                                  style={{ cursor: "pointer", transition: "background-color 0.3s" }}
                                />
                              </InputGroup>
                            ) : (
                              ""
                            );
                          }
                        })}
                      </FormGroup>
                    </Col>
                  </Row>

                  {editID !== null ? (
                    <Row>
                      <Col lg={12}>
                        <FormGroup>
                          {userAssignDataOrg?.map((assign, assignIndex) => {
                            return (
                              <>
                                <Label>ตำแหน่ง ที่ได้รับการดูแล</Label>
                                {masterdata?.users_position?.map(
                                  (config, configIndex) => (
                                    <InputGroup
                                      className="my-2"
                                      key={`assign_${assignIndex}_config_${configIndex}`}
                                    >
                                      {config.users_position_id !== 1 &&
                                      config.users_position_id !== 8 ? (
                                        assign.position_id === positionCheck &&
                                        config.users_position_id !== positionID1Check &&
                                        config.users_position_id !== positionID2Check &&
                                        config.users_position_id !== positionID3Check &&
                                        config.users_position_id !== positionID4Check &&
                                        config.users_position_id !== positionID5Check &&
                                        config.users_position_id !== positionID6Check &&
                                        config.users_position_id !== positionID7Check ? (
                                          <>
                                            <InputGroupText>
                                              <Input
                                                disabled
                                                defaultChecked
                                                type="radio"
                                                name="users_position_id"
                                                onChange={e => {
                                                  setPosition_ID(e.target.checked ? config.users_position_id : null);
                                                  setPosition_Name(e.target.checked ? config.users_position_name : null);
                                                }}
                                              />
                                            </InputGroupText>
                                            <Input
                                              readOnly
                                              defaultValue={config.users_position_name}
                                              style={{ cursor: "pointer", transition: "background-color 0.3s" }}
                                            />
                                          </>
                                        ) : config.users_position_id !== positionCheck ? (
                                          <>
                                            <InputGroupText key={`assign_1${assignIndex}_config_${configIndex}`}>
                                              <Input
                                                disabled
                                                addon
                                                type="radio"
                                                name="users_position_id"
                                                onChange={e => {
                                                  setPosition_ID(e.target.checked ? config.users_position_id : null);
                                                  setPosition_Name(e.target.checked ? config.users_position_name : null);
                                                }}
                                              />
                                            </InputGroupText>
                                            <Input
                                              readOnly
                                              defaultValue={config.users_position_name}
                                              style={{ cursor: "pointer", transition: "background-color 0.3s" }}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </InputGroup>
                                  )
                                )}
                              </>
                            );
                          })}
                        </FormGroup>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Fragment>
              ) : (
                ""
              )}
              {userEditData.map((edit, index) => {
                return (
                  <div key={index}>
                    <Row>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>คำสั่งการมอบหมายตำแหน่งข้าราชการแทน</Label>
                          <br />
                          <Button className="" type="button" onClick={handleButtonFileClick}>
                            <i className="fa-solid fa-upload"></i>อัพโหลดไฟล์
                          </Button>
                          <input
                            id="file-input"
                            type="file"
                            accept=".pdf*"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                        {EditFile !== null && fileUp === null ? (
                          <Row className="mb-2">
                            <Col lg={12}>
                              <Alert color="success">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <i className="fa-solid fa-file-pdf fa-2xl fa-beat" style={{ color: "#07e449" }}></i>
                                  </Col>
                                  <Col>
                                    <a href={`${API_URL}/${EditFile}`} target="_blank" className="text-muted font-weight-bold" rel="noreferrer">
                                      <p className="mb-0">
                                        <strong className="text-success">ไฟล์ที่อัพโหลด</strong>
                                      </p>
                                    </a>
                                  </Col>
                                </Row>
                              </Alert>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                        {fileUp !== null ? (
                          <Row className="mb-2">
                            <Col lg={12}>
                              <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <i className="fa-solid fa-file-pdf fa-2xl fa-beat" style={{ color: "#f81212" }}></i>
                                    </Col>
                                    <Col>
                                      <span className="text-muted font-weight-bold">{fileUp.name}</span>
                                      <p className="mb-0">
                                        <strong>{fileUp.formattedSize}</strong>
                                      </p>
                                    </Col>
                                    <Col className="col-auto">
                                      <button type="button" className="btn btn-link btn-sm text-danger" onClick={handleClearFile}>
                                        <i className="fa-solid fa-xmark-large"></i>
                                      </button>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                      </Col>
                      <br />
                      <Col lg={6}>
                        <InputGroup className="my-2">
                          <Input
                            readOnly
                            placeholder="Check it out"
                            defaultValue="ใช้งาน"
                            style={{ cursor: "pointer", transition: "background-color 0.3s" }}
                          />
                          <InputGroupText>
                            <Input
                              addon
                              defaultChecked={edit.status === 1}
                              type="checkbox"
                              name="status"
                              onChange={e => setStatus(e.target.checked ? 1 : 0)}
                            />
                          </InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>วันที่เริ่ม</Label>
                          <MyThaiDatePick
                            defaultValue={edit.date_start}
                            placeholderText="เลือกวันที่เริ่มต้น..."
                            setProbsDate={setStartDate}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>วันที่สิ้นสุด</Label>
                          <MyThaiDatePick
                            minDate={startDate}
                            defaultValue={edit.date_end}
                            placeholderText="เลือกวันที่สิ้นสุด..."
                            setProbsDate={setEndDate}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                );
              })}

              <br />
              <Row>
                <Col md={4} lg={6} xl={6}></Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} style={{ display: "flex", justifyContent: "end" }} className="mb-2">
                  <Button type="submit" color="success" style={{ width: "100%" }}>
                    บันทึก
                  </Button>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} style={{ display: "flex", justifyContent: "end" }} className="mb-2">
                  <Button color="danger" style={{ width: "100%" }} onClick={toggleRightCanvasFS}>
                    ยกเลิก
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
}

export default EditAssign;
